module.exports = __webpack_public_path__ + "img/c5.a87f2038.jpg";